<div class="is-flex gap-16 date-selector">
  <app-day-picker
    *ngIf="timeRange.dateBegin"
    [value]="timeRange" (valueChange)="selectDate($event)"
    [minDate]="today">
    <div class="is-flex is-space-between is-align-center is-cursor-pointer">
      <app-text [text]="endDateToDayDate(selectedEndDate$ | async)"
        class="mode-date is-family-semiBold text-14 text-grey-70"></app-text>
      <app-icon  name="dropdown-list" class="is-align-end text-24"></app-icon>
    </div>
  </app-day-picker>

  <div class="is-flex">

    <form [formGroup]="form" class="is-fullheight">
      <app-input-time formControlName="endDateTime" [errors]="errors$ | async"> </app-input-time>
    </form>

    <app-home-mode-control-validate class="validate"></app-home-mode-control-validate>
  </div>

</div>
